import { render, staticRenderFns } from "./setText.vue?vue&type=template&id=4dad878a&scoped=true"
import script from "./setText.vue?vue&type=script&lang=js"
export * from "./setText.vue?vue&type=script&lang=js"
import style0 from "./setText.vue?vue&type=style&index=0&id=4dad878a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dad878a",
  null
  
)

export default component.exports